/**
 * The one-line price a contractor sees where they decide (owner decision
 * 2026-10-20): on the sign-in chooser, under "A free page from us" in org
 * setup, and on Your page. The numbers are the Contractor Fee Schedule's
 * (./contractor-fee-schedule.ts §2 and §3); the schedule itself says the lead
 * price may differ by trade and that the portal shows it before accepting, and
 * the Billing page shows the organisation's own figures once it is enrolled.
 */
import { CONTRACTOR_FEE_SCHEDULE_PATH } from './contractor-fee-schedule';

export const CONTRACTOR_FEE_SUMMARY =
  'Free page. $45 per lead you accept, 30% of the accepted quote once the homeowner confirms the job is done. Nothing else.';

export function FeeSummary({ className = 'small muted' }: { className?: string }) {
  return (
    <p className={className} style={{ margin: 0 }}>
      {CONTRACTOR_FEE_SUMMARY}{' '}
      <a href={CONTRACTOR_FEE_SCHEDULE_PATH} target="_blank" rel="noopener noreferrer">
        Contractor Fee Schedule<span className="visually-hidden"> (opens in a new tab)</span>
      </a>
    </p>
  );
}
